import React, { useEffect, useState } from 'react'
import Header from "../components/Header";
import axiosInstance from '../utils/axiosInstance';
import Session from "../utils/sessionStorage";
import { X_API_KEY } from '../constants/ServerUrl';
import nodata from "../assets/images/nodata.png";
import { toast, ToastContainer } from 'react-toastify';
import Button from '../components/form/Button';
import Confirmation from '../components/Confirmation';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import { getOfferCode, isAddPlanDisabled } from '../utils/profileutils';
import { useNavigate } from 'react-router-dom';
import { ReactSVG } from "react-svg";
import dataicon from "../assets/svgs/dataicon.svg";
import callicon from "../assets/svgs/callicon.svg";

const MoreDetail = () => {
  const result = Session.get("_user_");
  const userData = result ? JSON.parse(result) : "";
  const [subsLoading, setSubsLoading] = useState(true);
  const [subsData, setSubsData] = useState([]);
  const [isXoxAccModalShow, setIsXoxAccModalShows] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [isPromptModalShows, setIsPromptModalShows] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState('');
  const [accountData, setAccountData] = useState({
    balance: "",
    expireDate: "",
  });
  const [accountLoading, setAccountLoading] = useState(true);
  const [disableAddPlan, setDisableAddPlan] = useState(false);

  // const [offerCode, setOfferCode] = useState("");
  const navigate = useNavigate();

  const offerCode = getOfferCode();
  console.log("ofer ", offerCode)

  console.log("pakage data", subsData)
  console.log("userData data", userData)


  async function getProfileData() {
    try {
      const response = await axiosInstance.get("api/v1/get-profile", {
        params: {
          msisdn: userData?.mobileNo,
        },
        headers: {
          'X-API-KEY': X_API_KEY,
        },
      });
      if (response.status === 200) {
        if (userData?.customerType === "StdCDD") {
          const profile = response?.data?.profile;
          Session.set("profile", JSON.stringify(profile));
          if (profile) {
            setIsXoxAccModalShows(false);
          } else {
            setIsXoxAccModalShows(true);
          }
        } else {
          const profile = response?.data?.profile;
          Session.set("profile", JSON.stringify(profile));
        }
        getAccount();
      }

    } catch (error) {
      console.log("error tftyft", error);

      if (
        error?.response?.data?.message === "getPrepaidProfile : Can't find subscription by given msisdn! "
      ) {
        console.log('drdrd')
        setIsPromptModalShows(true);
      }
    }
  }

  async function getAccount() {
    try {
      setAccountLoading(true);
      const response = await axiosInstance.get("api/v1/get-account", {
        params: {
          msisdn: userData?.mobileNo,
        },
        headers: {
          'X-API-KEY': X_API_KEY,
        },
      });
      if (response.status === 200) {
        const account = response?.data?.account;
        setAccountLoading(false);
        setAccountData((prev) => ({
          ...prev,
          balance: account?.totalBal,
          expireDate: account?.expiryDate,
        }));
        // getSubsPlan();
      }
    } catch (error) {
      setAccountLoading(false);
    } finally {
      setAccountLoading(false)
    }
  }

  async function getSubsPlan() {
    setSubsLoading(true);
    try {
      const url = disableAddPlan
        ? "api/v1/subscription-info"
        : "api/v2/subscription-info";
      const response = await axiosInstance.get(url, {
        params: {
          msisdn: userData?.mobileNo,
          // offer_code: offerCode
        },
        headers: {
          'X-API-KEY': X_API_KEY,
        },
      });

      if (response.status === 200) {
        // setSubsLoading(false);
        setSubsData(response?.data?.subscriptions);
      }
    } catch (error) {
      setSubsData([]);
      // setSubsLoading(false);
      if (
        error?.response?.data?.message ===
        "getDataSubscription : Can't find subscription by given msisdn!"
      ) {
        setErrMsg("No Subscription Record found");
      }
      // toast.error(error?.response?.data?.message, {
      //   position: "top-center",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      // });
    }
    finally {
      setSubsLoading(false);
    }
  }

  const handleEndDataConfirmation = () => {
    setConfirmationAction('endData');
    setIsConfirmModal(true);
  };

  const handleStopRecurringConfirmation = () => {
    setConfirmationAction('stopRecurring');
    setIsConfirmModal(true);
  };

  const handleEtendValidity = () => {
    navigate("/extend-validity");

  };

  const handleAddOnPlan = () => {
    navigate("/add-on-plan");

  };

  function calculateDaysDifference(expirationDate) {
    const currentDate = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" })
    );
    const expiryDate = new Date(expirationDate);
    const differenceInTime = expiryDate - currentDate; // Difference in milliseconds
    const differenceInDays = Math.ceil(
      differenceInTime / (1000 * 60 * 60 * 24)
    ); // Convert to days
    return differenceInDays > 0 ? differenceInDays : 0; // Return 0 if expiration is in the past
  }

  const formatRemainingQuota = (remainingQuota) => {
    const cleanedQuota = extractQuotaValue(remainingQuota); // Use the extracted value
    return `${cleanedQuota.toFixed(2)} GB`; // Append 'GB' and ensure 2 decimal points
  };

  const extractQuotaValue = (remainingQuota) => {
    if (!remainingQuota) return 0; // Fallback for missing data
    const cleanedQuota = parseFloat(remainingQuota.split(" ")[0]); // Extract numeric part as a float
    return isNaN(cleanedQuota) ? 0 : cleanedQuota; // Fallback for invalid numbers
  };

  useEffect(() => {

    getProfileData();

  }, []);

  useEffect(() => {
    setDisableAddPlan(isAddPlanDisabled());
  }, [offerCode]);

  useEffect(() => {
    if (disableAddPlan !== null) {
      getSubsPlan();
    }
  }, [disableAddPlan]);

  useEffect(() => {
    setDisableAddPlan(isAddPlanDisabled());
  }, []);

  return (
    <div className='bg-accent-grey-50 h-screen lg:w-[450px] w-full mx-auto'>
      <Header />
      <>
        <div className='mt-4'>
          {subsData?.length === 0 ? (<></>) : (<>
            <div className=' py-5 px-4 '>
              <div className='bg-[#2E31910D] rounded-3xl py-6 px-[15px] flex flex-col gap-[2px]'>
                <p className='text-[17px] font-semibold text-primary'>{subsData?.[0]?.tier}</p>
                <p className='text-[13px]'>{userData?.mobileNo}</p>
                <p className='text-[13px] font-[600]'><span className='text-[#5E5E5E] font-[400]'>End On </span>
                  {new Date(subsData?.[0]?.expiration.replace(" ", "T")).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true
                  })}
                </p>
                {subsData?.[0]?.validity.toLowerCase() !== "daily" && (
                  <>
                    <div className='mt-[14px] py-[10px]'>
                      <div className="grid grid-cols-2 gap-3">
                        <Button
                          classes={"text-primary border border-[2px] border-primary bg-white"}
                          children={"End Data"}
                          roundness={"pill"}
                          type={"button"}
                          size={"costum"}
                          eventAction={handleEndDataConfirmation}
                          intent={"more"}
                        />
                        <Button
                          classes={"w-full px-1"}
                          children={"Stop Recurring"}
                          intent={"primary"}
                          roundness={"round"}
                          type={"button"}
                          size={"costum"}
                          eventAction={handleStopRecurringConfirmation}
                        />
                      </div>
                    </div>
                    <div className='flex flex-col gap-1 mt-1'>
                      <p className="text-[#1111117A] text-[13px]">
                        To cancel your subscribed package instantly, click <strong>“End Data”</strong>.
                      </p>
                      <p className="text-[#1111117A] text-[13px]">
                        To stop auto re-newal weekly or monthly package, click <strong>“Stop Recurring”</strong>.
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </>)}

          {subsLoading ? (
            <>
              <div className="animate-pulse flex flex-col justify-center  bg-white mt-[33px] h-20 rounded-lg mb-3 space-y-3 p-3">
                <div className="h-3 w-1/2 bg-slate-300 rounded-md"></div>
                <div className="h-3 w-full bg-slate-300 rounded-md"></div>
              </div>
            </>

          ) : (
            <div className="px-4 py-8 mt-8 bg-[#2E31910D] rounded-3xl relative mb-2 space-y-2">
              {subsData?.length > 0 &&
                <p className="font-semibold text-[17px]">
                  Remaining Usage
                </p>
                }
              {subsData?.length === 0 ? (

                <div className="flex flex-col justify-center  bg-white mt-[33px] h-44 rounded-lg mb-3">
                  <div className="mx-auto">
                    <img src={nodata} alt="no data" className="w-full h-full" />
                  </div>
                  <p className="font-poppins text-base font-medium text-accent-silver-900 text-center">
                    No Plan Subscribed
                  </p>
                </div>
              ) : (
                <div className="flex flex-col gap-4 items-center">
                  {subsData?.map((item, index) => {
                    const {
                      expiration,
                      volume,
                      remainingPercentage,
                      remainingQuota,
                      tier,
                      validity,
                      capped_speed,
                      capped_volume, //total
                      capped,          //remaining
                      hotspot_speed,
                      hotspot_volume,
                      hotspot,
                      uncapped,
                      uncapped_speed,
                      uncapped_volume,
                      free_call_type,
                      free_call,
                      free_call_volume
                    } = item;

                    const daysRemaining = expiration
                      ? calculateDaysDifference(expiration)
                      : "N/A";
                    const remi = (daysRemaining * 100) / 30;
                    const remaining_capped_GB = capped / 1024;
                    const remaining_hotspot_GB = hotspot / 1024;
                    const capped_volume_GB = capped / 1024;
                    const total_capped_volume_GB = capped_volume / 1024;
                    const total_hotspot_volume_GB = hotspot_volume / 1024;
                    const hotspot_volume_GB = hotspot / 1024;
                    const uncapped_volume_GB = uncapped / 1024;
                    const quotaValue = extractQuotaValue(remainingQuota);
                    const formattedQuota = formatRemainingQuota(remainingQuota);
                    const capped_used = total_capped_volume_GB - remaining_capped_GB;
                    const hotspot_used = total_hotspot_volume_GB - remaining_hotspot_GB;
                    const used_call_minutes = free_call_volume - free_call;
                    const randomNumber =
                      Math.floor(Math.random() * (100 - 50 + 1)) + 50;

                    return (
                      <div key={index} className="flex flex-col gap-3 items-center">
                        <div className="pb-2">
                          {disableAddPlan ? (
                            <div className="w-full flex items-start justify-around gap-4 mt-5">
                              <div className="w-full flex-col items-center justify-center">
                                <CircularProgressbar
                                  value={remi}
                                  text={`${daysRemaining} days`}
                                  styles={buildStyles({
                                    pathColor: "red",
                                    textColor: "black",
                                    textSize: "18px",
                                  })}
                                />
                                <div className=" flex flex-col justify-center items-center ">
                                  <p className=" pt-2 text-black text-sm opacity-[60%]">
                                    {validity ? validity : "N/A"}
                                  </p>
                                  <h3 className=" text-primary text-sm">Validity</h3>
                                </div>
                              </div>
                              <div className="w-full flex-col items-center justify-center">
                                <CircularProgressbar
                                  value={
                                    remainingPercentage ? remainingPercentage : 95
                                  }
                                  text={
                                    tier === "UNL35" || tier === "FW25"
                                      ? <>
                                        Unlimited
                                        <tspan x="50%" dy="1em">GB</tspan>
                                      </>
                                      : `${formattedQuota}`
                                  }
                                  styles={buildStyles({
                                    pathColor: "red",
                                    textColor: "black",
                                    textSize: "17.5px",
                                  })}
                                />
                                <div className=" flex flex-col justify-center items-center  ">
                                  <p className=" pt-2 text-black text-sm opacity-[60%]">
                                    {tier === "UNL35" || tier === "FW25"
                                      ? "Unlimited GB"
                                      : volume
                                        ? volume
                                        : "N/A"}
                                  </p>
                                  <h3 className=" text-primary">
                                    {volume ? "H/S Internet" : "Basic Internet"}{" "}
                                  </h3>
                                </div>
                              </div>
                              <div className="w-full flex-col items-center justify-center">
                                <CircularProgressbar
                                  value={0}
                                  text="0.0"
                                  styles={buildStyles({
                                    pathColor: "red",
                                    textColor: "black",
                                    textSize: "18px",
                                  })}
                                />
                                <div className=" flex flex-col justify-center items-center  ">
                                  <p className=" pt-2 text-black text-sm opacity-[60%]">
                                    0.0
                                  </p>
                                  <h3 className=" text-primary">Voice Call</h3>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="w-full grid grid-cols-2 items-start justify-around gap-4">
                              {/* <div className="w-full flex-col items-center justify-center">
                                <CircularProgressbar
                                  value={remi}
                                  text={`${daysRemaining} days`}
                                  styles={buildStyles({
                                    pathColor: "red",
                                    textColor: "black",
                                    textSize: "18px",
                                  })}
                                />
                                <div className=" flex flex-col justify-center items-center ">
                                  <p className=" pt-2 text-black text-sm opacity-[60%]">
                                    {validity ? validity : "N/A"}
                                  </p>
                                  <h3 className=" text-primary text-sm">Validity</h3>
                                </div>
                              </div> */}
                              {(uncapped > 0 || uncapped_volume > 0) && (
                                // <div className="w-full flex-col items-center justify-center">
                                //   <CircularProgressbar
                                //     value={
                                //       uncapped_volume
                                //         ? (parseFloat(uncapped) / parseFloat(uncapped_volume)) * 100
                                //         : 100
                                //     }
                                //     text={
                                //       uncapped ?
                                //         <>
                                //           {uncapped_volume_GB > 90 ? "∞" : <> {uncapped_volume_GB} GB</>}
                                //         </> : <>NA</>
                                //     }
                                //     styles={buildStyles({
                                //       pathColor: "red",
                                //       textColor: "black",
                                //       textSize: uncapped_volume_GB > 90 ? "40px" : "17.5px",
                                //     })}
                                //   />
                                //   <div className=" flex flex-col justify-center items-center  ">
                                //     <p className=" pt-2 text-black text-sm opacity-[60%]">
                                //       {uncapped_speed ? uncapped_speed : "N/A"}
                                //     </p>
                                //     <h3 className=" text-primary">
                                //       H/S Data
                                //     </h3>
                                //   </div>

                                // </div>

                                <div className="w-full flex flex-col justify-center bg-white rounded-3xl p-3 col-span-2">
                                  <div className="flex items-center gap-[10px]">
                                    <ReactSVG src={dataicon} />
                                    <div className="font-semibold text-[17px] flex items-center gap-[2px]">
                                      {uncapped ? (
                                        uncapped_volume_GB > 90 ? (
                                          <div>H/S Data <span className="text-[13px] font-normal text-gray">Unlimited</span></div>
                                        ) : (
                                          <>
                                            H/S Data {uncapped_volume_GB.toFixed(2)} <span className="text-[13px] font-normal text-gray">GB</span>
                                          </>
                                        )
                                      ) : (
                                        "N/A"
                                      )}
                                    </div>
                                  </div>

                                  <div className="mt-[21px]">
                                    {uncapped_volume_GB < 90 && (
                                      <p className="text-[13px]">
                                        <span className="text-gray">Used: </span>
                                        {((uncapped_volume - uncapped) / 1024).toFixed(2)} GB out of {uncapped_volume_GB.toFixed(2)} GB
                                      </p>
                                    )}
                                  </div>

                                  <div className="w-full bg-primary/10 rounded-full h-[15px] overflow-hidden mt-[11px]">
                                    <div
                                      className="h-[15px] bg-gradient-to-r from-gradiantprimary to-gradiantsecondary transition-all duration-700 rounded-full"
                                      style={{
                                        width: uncapped_volume
                                          ? `${(parseFloat(uncapped) / parseFloat(uncapped_volume)) * 100}%`
                                          : "100%",
                                      }}
                                    ></div>
                                  </div>

                                  <div className="flex justify-between mt-2 text-gray text-[13px] pb-2">
                                    <p className="">
                                      {uncapped_speed ? uncapped_speed + " Data" : "N/A"}
                                    </p>
                                    <p>
                                      Remaining: <span className="text-black font-semibold">{uncapped_volume_GB > 90 ? "unlimited" : <>{(uncapped / 1024).toFixed(2)} GB</>}</span>
                                    </p>
                                  </div>
                                </div>
                              )}
                              {(capped > 0 || capped_volume > 0) && (
                                // <div className="w-full flex-col items-center justify-center">
                                //   <CircularProgressbar
                                //     value={
                                //       capped_volume
                                //         ? (parseFloat(capped) / parseFloat(capped_volume)) * 100
                                //         : 100
                                //     }
                                //     text={
                                //       capped ?
                                //         <>
                                //           {capped_volume_GB > 40 ? "∞" : <> {capped_volume_GB} GB</>}
                                //         </> : <>NA</>
                                //     }
                                //     styles={buildStyles({
                                //       pathColor: "red",
                                //       textColor: "black",
                                //       textSize: capped_volume_GB > 40 ? "40px" : "17.5px",
                                //     })}
                                //   />
                                //   <div className=" flex flex-col justify-center items-center  ">
                                //     <p className=" pt-2 text-black text-sm opacity-[60%]">
                                //       {capped_speed ? capped_speed : "N/A"}
                                //     </p>
                                //     <h3 className=" text-primary">
                                //       Data
                                //     </h3>
                                //   </div>

                                // </div>

                                <div className={`w-full flex flex-col justify-center bg-white rounded-3xl p-3 ${(uncapped > 0 || uncapped_volume > 0) ? 'col-span-1' : 'col-span-2'}`}>
                                    <div className="flex items-center gap-[10px]">
                                      <ReactSVG src={dataicon} />
                                      <div className="font-semibold text-[17px] flex items-center gap-[2px]">
                                        {capped ? (
                                          total_capped_volume_GB > 40 ? (
                                            <div> Data <span className="text-[13px] font-normal text-gray">Unlimited</span></div>
                                          ) : (
                                            <>
                                              Data {total_capped_volume_GB.toFixed(2)} <span className="text-[13px] font-normal text-gray">GB</span>
                                            </>
                                          )
                                        ) : (
                                          "N/A"
                                        )}
                                      </div>
                                    </div>

                                    <div className="mt-[21px]">
                                      {total_capped_volume_GB < 40 && (
                                        <p className="text-[13px]">
                                          <span className="text-gray">Used: </span>
                                          {capped_used.toFixed(2)} GB out of {total_capped_volume_GB.toFixed(2)} GB
                                        </p>
                                      )}
                                    </div>

                                    <div className="w-full bg-primary/10 rounded-full h-[15px] overflow-hidden mt-[11px]">
                                      <div
                                        className="h-[15px] bg-gradient-to-r from-gradiantprimary to-gradiantsecondary transition-all duration-700 rounded-full"
                                        style={{
                                          width: capped_volume
                                            ? `${(parseFloat(capped) / parseFloat(capped_volume)) * 100}%`
                                            : "100%",
                                        }}
                                      ></div>
                                    </div>

                                    <div className="flex justify-between mt-2 text-gray text-[13px] pb-2">
                                      {/* <p className="">
                                        {capped_speed ? capped_speed + " Data" : "N/A"}

                                      </p> */}
                                      <p>
                                        Remaining: <span className="text-black font-semibold">{remaining_capped_GB > 40 ? "unlimited" : <> {remaining_capped_GB.toFixed(2)} GB</>}</span>
                                      </p>
                                    </div>
                                  </div>
                              )}

                              {(hotspot > 0 || hotspot_volume > 0) && (
                                // <div className="w-full flex-col items-center justify-center">
                                //   <CircularProgressbar
                                //     value={
                                //       hotspot_volume
                                //         ? (parseFloat(hotspot) / parseFloat(hotspot_volume)) * 100
                                //         : 100
                                //     }
                                //     text={
                                //       hotspot_volume ?
                                //         <>
                                //           {<> {hotspot_volume_GB} GB</>}
                                //         </> : <>NA</>
                                //     }
                                //     styles={buildStyles({
                                //       pathColor: "red",
                                //       textColor: "black",
                                //       textSize: "17.5px",
                                //     })}
                                //   />
                                //   <div className=" flex flex-col justify-center items-center  ">
                                //     <p className=" pt-2 text-black text-sm opacity-[60%]">
                                //       {hotspot_speed ? hotspot_speed : "N/A"}
                                //     </p>
                                //     <h3 className=" text-primary">
                                //       Hotspot
                                //     </h3>
                                //   </div>

                                // </div>

                                <div className="w-full flex flex-col justify-center bg-white rounded-3xl p-3">
                                  <div className="flex items-center gap-[10px]">
                                    <ReactSVG src={dataicon} />
                                    <div className="font-semibold text-[17px]">
                                      {hotspot_volume ? (
                                        total_hotspot_volume_GB > 0 ? (
                                          <>
                                            Hotspot{" "}
                                            <span className="whitespace-nowrap">
                                              {total_hotspot_volume_GB.toFixed(2)}{" "}
                                              <span className="text-[13px] text-gray">GB</span>
                                            </span>
                                          </>

                                        ) : (
                                          "unlimited"
                                        )
                                      ) : (
                                        "N/A"
                                      )}
                                    </div>
                                  </div>

                                  <div className="mt-[21px]">
                                    {total_hotspot_volume_GB > 0 && (
                                      <p className="text-[13px]">
                                        <span className="text-gray">Used: </span>
                                        {hotspot_used.toFixed(2)} GB out of {total_hotspot_volume_GB.toFixed(2)} GB
                                      </p>
                                    )}
                                  </div>

                                  <div className="w-full bg-primary/10 rounded-full h-[15px] overflow-hidden mt-[11px]">
                                    <div
                                      className="h-[15px] bg-gradient-to-r from-gradiantprimary to-gradiantsecondary transition-all duration-700 rounded-full"
                                      style={{
                                        width: hotspot_volume
                                          ? `${(parseFloat(hotspot) / parseFloat(hotspot_volume)) * 100}%`
                                          : "100%",
                                      }}
                                    ></div>
                                  </div>

                                  <div className="mt-2 text-gray text-[13px] pb-2">
                                    <p className="flex justify-between" >
                                      Remaining:{" "}
                                      <span className="text-black font-semibold">
                                        {remaining_hotspot_GB > 90 ? "unlimited" : `${remaining_hotspot_GB.toFixed(2)} GB`}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              )}
                              {/* <div className="w-full flex-col items-center justify-center">
                                <CircularProgressbar
                                  value={100}
                                  text={free_call_volume ?
                                    <>
                                      {free_call_volume === "Unlimited" ? "∞" : <> {free_call_volume} Mins</>}
                                    </> : <>NA</>}
                                  styles={buildStyles({
                                    pathColor: "red",
                                    textColor: "black",
                                    textSize: free_call_volume === "Unlimited" ? "40px" : "18px",
                                  })}
                                />
                                <div className=" flex flex-col justify-center items-center  ">
                                  <p className=" pt-2 text-black text-sm opacity-[60%]">
                                    {free_call_type}
                                  </p>
                                  <h3 className=" text-primary">Minutes</h3>
                                </div>
                              </div> */}
                              <div className="w-full flex flex-col justify-center bg-white rounded-3xl p-3">
                                <div className="flex items-center gap-[10px]">
                                  <ReactSVG src={callicon} />
                                  <div className="font-semibold text-[17px]">
                                    {free_call_volume ? (
                                      free_call_volume === "Unlimited" ? (
                                        <>
                                          Call {" "}<span className="text-[13px] font-normal text-gray">Unlimited</span>
                                        </>
                                      ) : (
                                        <>
                                          Call {free_call_volume}{" "}
                                          <span className="text-[13px] text-gray">Mins</span>
                                        </>
                                      )
                                    ) : (
                                      "N/A"
                                    )}
                                  </div>
                                </div>

                                <div className="mt-[21px]">
                                  {free_call_volume !== "Unlimited" && (
                                    <p className="text-[13px]">
                                      <span className="text-gray">Used: </span>
                                      {used_call_minutes ? used_call_minutes : "N/A"}{" "} Mins
                                    </p>
                                  )}
                                </div>

                                <div className="w-full bg-primary/10 rounded-full h-[15px] overflow-hidden mt-[11px]">
                                  <div
                                    className="h-[15px] bg-gradient-to-r from-gradiantprimary to-gradiantsecondary transition-all duration-700 rounded-full"
                                    style={{
                                      width:
                                        free_call_volume && free_call_volume !== "Unlimited"
                                          ? `${(parseFloat(used_call_minutes) / parseFloat(free_call_volume)) * 100}%`
                                          : "100%",
                                    }}
                                  ></div>
                                </div>

                                <div className="flex justify-between mt-2 text-gray text-[13px] pb-2">
                                  {free_call_type ? free_call_type : "N/A"}
                                  {":"}
                                  <p>
                                    <span className="text-black font-semibold">
                                      {free_call_volume === "Unlimited"
                                        ? " Unlimited"
                                        : `${free_call_volume && used_call_minutes
                                          ? free_call_volume - used_call_minutes
                                          : 0
                                        } Mins`}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}

                </div>
              )}
            </div>
          )}
          <div>
            {subsData?.[0]?.validity.toLowerCase() === "monthly" && subsData.length > 0 && (
              <div className="flex flex-wrap gap-3 justify-center mt-16">
                {/* <Button
                  disable={disableAddPlan}
                  classes={"py-2 disabled:cursor-not-allowed disabled:opacity-50 "}
                  children={"Extend Validity"}
                  intent={"primary"}
                  roundness={"round"}
                  type={"button"}
                  size={"costum"}
                  eventAction={handleEtendValidity}
                /> */}
                <Button
                  classes={"disabled:cursor-not-allowed w-full disabled:opacity-50 mb-3 mx-2"}
                  disable={disableAddPlan}
                  children={"Add-on plan"}
                  intent={"primary"}
                  roundness={"round"}
                  type={"button"}
                  size={"costum"}
                  eventAction={handleAddOnPlan}
                />
              </div>
            )}
          </div>
        </div>
      </>
      {isConfirmModal && (
        <Confirmation close={() => {
          setIsConfirmModal(false);
          getSubsPlan();
        }}
          actionType={confirmationAction} />
      )}
      <ToastContainer />
    </div>
  )
}

export default MoreDetail
